<template>
  <div class="quantity-selector">
    <div class="flex-container">
      <span class="minus-one btn" id="descrease-quantity-btn" @click="updateQuantity(-1)">
        <font-awesome-icon icon="minus"></font-awesome-icon>
      </span><!-- /.btn -->
      <span class="quantity-selected">{{quantitySelected}}</span><!-- /.quantity-selected -->
      <span class="plus-one btn" id="increase-quantity-btn" @click="updateQuantity(1)">
        <font-awesome-icon icon="plus"></font-awesome-icon>
      </span><!-- /.btn -->
    </div><!-- /.flex-container -->
  </div><!-- /.quantity-selector -->
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "QuantitySelector",
  methods: {
    ...mapActions(["set"]),
    updateQuantity(value) {
      let newVal = this.quantitySelected + value;
      if (newVal >= 1) {
        this.set({ var: "quantitySelected", val: newVal })
      }
    }
  },
  computed: {
    ...mapState(["quantitySelected"])
  }
}
</script>
